// The one-click label for a plan-of-action step. A payment request to a slice says how many it reaches.
export const suggestionActionLabel = (suggestion, count) => {
  if (suggestion.kind === "SendDocuments") return "Send documents";
  if (suggestion.kind === "CreateTask") return "Mark done";
  return count != null && !suggestion.customerId ? `Send to ${count.toLocaleString()}` : "Send";
};
